(() => {
  const emitSecondaryEvent = (eventName, parameters = {}) => {
    const eventParameters = {
      ...parameters,
      page_location: window.location.href,
      page_path: window.location.pathname,
    };

    if (typeof window.gtag === 'function') {
      window.gtag('event', eventName, eventParameters);
    } else {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: eventName, ...eventParameters });
    }

    document.dispatchEvent(
      new CustomEvent('handymite:secondary-event', {
        detail: { event: eventName, ...eventParameters },
      }),
    );
  };

  document.addEventListener('click', (event) => {
    const amazonLink = event.target.closest('[data-handymite-amazon-link]');
    if (!amazonLink) return;

    emitSecondaryEvent('amazon_outbound_click', {
      link_url: amazonLink.href,
      link_domain: 'amazon.co.jp',
      product_id: amazonLink.dataset.productId || '',
      product_handle: amazonLink.dataset.productHandle || '',
      product_name: amazonLink.dataset.productTitle || '',
    });
  });

  const newsletterSuccess = document.querySelector('.newsletter-form__message--success');
  if (!newsletterSuccess) return;

  const newsletterForm = newsletterSuccess.closest('form');
  const source = newsletterForm?.id === 'ContactFooter' ? 'footer' : 'section';
  const dedupeKey = `handymite_email_signup_success:${window.location.pathname}:${source}`;

  if (window.sessionStorage.getItem(dedupeKey)) return;

  window.sessionStorage.setItem(dedupeKey, '1');
  emitSecondaryEvent('email_signup_success', {
    signup_source: source,
    form_id: newsletterForm?.id || '',
  });
})();
